import { FC } from "react";
import { Box, Container, Heading } from "@radix-ui/themes";
import { useTenantEvents } from "@/features/events/hooks/useTenantEvents";
import { SingleEventCard } from "@/features/events/components/single/SingleEventCard";
import { Loader } from "@/components";

export const SingleZoneEvents: FC = (): JSX.Element => {
  const { data, loading, error } = useTenantEvents();

  if (loading) {
    return <Loader />;
  }

  if (error) {
    return <Box>Error: {error.message}</Box>;
  }

  const filteredData = data?.filter(
    (event) => event.endDate.toDate() >= new Date()
  );

  return (
    <Box className="align-full" style={{ backgroundColor: "var(--accent-10)" }}>
      <Container py="9" px={{ initial: "4", md: "2", xl: "0" }}>
        <Heading>Upcoming events</Heading>
        {filteredData &&
          filteredData.map((event) => {
            return <SingleEventCard {...event} key={event.slug} />;
          })}
      </Container>
    </Box>
  );
};
